import axios from "axios";
import API, { shipNames } from "../helpers/api";
import FileSaver from "file-saver";

export const AddAttachment = (postItem, index) => {
  const data =new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "AttchmentUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const AddGAttachment = (postItem, index) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "GAttchmentUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GAttchmentFailure",
          error: "ERROR",
        });
      });
  };
};
// export const AddnewdocAttachmnt = (postItem, index) => {
//   const data = new FormData();
//   data.append("file", postItem);

//   let url = `${API.AttachmentAPI}`;
//   return (dispatch) => {
//     axios
//       .post(url, data)
//       .then((response) => {
//         dispatch({
//           type: "newdocUploaded",
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: "GAttchmentFailure",
//           error: "ERROR",
//         });
//       });
//   };
// };

export const AddEquipManualAttachment = (postItem, index) => {
  const data = new FormData();
  data.append("file", postItem);
  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "EquipManualAttchmentUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "EquipManualAttchmentFailure",
          error: "ERROR",
        });
      });
  };
};

export const AddnewdocAttachmnt = (postItem, index) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "newdocUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GAttchmentFailure",
          error: "ERROR",
        });
      });
  };
};

export const AddSDocAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "SDocAttchmentUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "SDocAttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const DownloadAttachment = (attachmentName, attachmentGuid) => {
  let encodedAttachmentName = btoa(unescape(encodeURIComponent(attachmentName)));
  let url = `${API.DownloadAttachmentAPI}?filename=${encodedAttachmentName}&guidValue=${attachmentGuid}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        var mime = require('mime-types'),
          fileExtension = mime.extension(response.data.type)
        FileSaver.saveAs(blob, attachmentName + "." + fileExtension);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const DownloadFirePlanAttachment = (firePlanName, firePlanGUID) => {
  let url = `${API.DownloadAttachmentAPI}?filename=${btoa(firePlanName)}&guidValue=${firePlanGUID}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        var mime = require('mime-types'),
          fileExtension = mime.extension(response.data.type)
        FileSaver.saveAs(blob, firePlanName + "." + fileExtension);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};
